import { gql } from "@apollo/client";
export const stripePayment = gql`
mutation purchaseMemorabiliaWithStripe($athleteUserIds:[String!]!, $paymentInfo:PaymentInfoInput!,$savedCardId:String!) {
    purchaseMemorabiliaWithStripe (athleteUserIds:$athleteUserIds, paymentInfo: $paymentInfo,savedCardId:$savedCardId) 
    { 
        status 
        data  
    }
}`;

export const confirmPaymentWithStripe = gql`
mutation confirmPaymentWithStripe($paymentIntentId:String!,$savedCardId:String!) {
    confirmPaymentWithStripe (paymentIntentId:$paymentIntentId, savedCardId:$savedCardId) 
    { 
        status 
        data  
    }
}`;

export const deleteCards = gql`
mutation deleteFanStripePaymentDetail($cardId: String!) {
     deleteFanStripePaymentDetail(cardId: $cardId) { data status}
     }
`;

